import i18n from "@/i18n";

export default class ErrorMessageService {
  static errorMessage(error: any): string {
    if (error.response) {
      if (error.response.status === 401)
        return i18n.tc("error.not.authorized.message");
      return error.response.data.errorMessage;
    }
    if (error.message === "Request failed with status code 401")
      return i18n.tc("error.not.authorized.message");
    if (error.message === "Request failed with status code 404")
      return i18n.tc("error.not.found.message");
    if (error.message === "Network Error")
      return i18n.tc("error.connection.message");
    if (error.message === "timeout") return i18n.tc("error.connection.message");
    console.log(error.message);
    return i18n.tc("error.internal.server.message");
  }
}
